import { RootState } from '../../store';

export const getUsersListSelector = (state: RootState) => state.userSliceReducer.usersList;
